<script>
    import { onMount, tick, createEventDispatcher } from "svelte";
    import Chart from 'chart.js/auto';
    import chartService from '../../../services/chart.js';
    import Gradient from "../../../services/gradient.js";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();
    let { certsCount = {} } = $props();

    let canvas = $state();
    let chart;
    let totals = $state({});
    let count = 0;

    let kinds = [
        "public_ip",
        "private_ip",
        "hostname"
    ]
    let labels = {
        "public_ip": $format("asset.kind.public_ip.plural"),
        "private_ip": $format("asset.kind.private_ip.plural"),
        "hostname": $format("asset.kind.hostname.plural")
    };


    for(let [key, value] of Object.entries(certsCount)){
        if(value > 0) count++;
    }

    let gradientArray = new Gradient()
        //.setColorGradient("#B10c52", "#230B0C")
        .setColorGradient("#343a40","#3c8dbc") // opcion 1
        .setMidpoint(((count <= 2) ? 2 : count))
        .getColors();
    ;
    for(let [index, color] of gradientArray.entries()){
        gradientArray[index] = color + "AE";
    }

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : gradientArray,
                data: [],
            },
        }

        for (const s of kinds) {
            totals[s] = certsCount[s];
        }

        for (const [k, v] of Object.entries(totals)) {
            if(totals[k] > 0){
                chartData.labels.push(labels[k]);
                chartData.datasets.data.push(v);
            }
        }

        chart   = new Chart(context, {
            type: 'doughnut',
            options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide

                //clip: false,
                responsive: true,
                maintainAspectRatio: false,
                borderWidth     : 1,
                aspectRatio: 1,
                //cutout: '50%',
                weight : 20,
                plugins:{
                    legend: {
                        position: 'bottom',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 12
                            }
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    let kind = Object.keys(labels).filter(k=>labels[k] == event.chart.tooltip.title[0])[0];
                    dispatch("advancedSearch", {asset__kind__in: kind});
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets]
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{totals["critical"] == 0 && totals["high"] == 0 && totals["medium"] == 0 && totals["low"] == 0}" ></canvas>
